'use strict';

window.slate = window.slate || {};
window.theme = window.theme || {};
window.POV = window.POV || {};


/*================ Slate ================*/

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - NodeList of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = options.tableWrapperClass || '';

    options.tables.forEach(function(table) {
      // Create a wrapper div with the specified class
      var wrapper = document.createElement('div');
      wrapper.className = tableWrapperClass;

      // Insert the wrapper div before the table
      table.parentNode.insertBefore(wrapper, table);
      // Move the table into the wrapper
      wrapper.appendChild(table);
    });
  },
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

POV.Currency = (function() {
  var moneyFormat = POV.Liquid.moneyFormat;

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  function defaultTo(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
  }
})();


(function Slider(namespace){
  'use strict';

  var initSequence = compose(publicAPI, setControlsDisabled, setControlsVisibility, setEvents, collate);
  var reInitSequence = compose(setControlsDisabled, setControlsVisibility);
  var triggerClickSequence = compose(setScroll, getScrollOffset, setDirection);

  try {
    namespace.Slider = nodeList('[data-slider]').map(initSequence);
  } catch(error) {
    console.log(error)
  }
  
  function publicAPI(data) {
    return {
      id: data.container.getAttribute('data-slider'),
      elements: {
        container: data.container,
        triggerPrev: data.triggerPrev,
        triggerNext: data.triggerNext,
        track: data.track,
        items: data.items
      },
      reinit: partial(reInitSequence, data),
      canScrollPrev: partial(canScrollPrev, data),
      canScrollNext: partial(canScrollNext, data),
      scrollToStart: partial(scrollToStart, data),
      scrollToEnd: partial(scrollToEnd, data)
    }
  }

  // Get all nodes needed
  function collate(node) {
    return {
      container: node,
      triggerPrev: node.querySelector('[data-slider-trigger-prev]'),
      triggerNext: node.querySelector('[data-slider-trigger-next]'),
      track: node.querySelector('[data-slider-track]'),
      get items() {
        var childrenArray = Array.prototype.slice.call(node.querySelector('[data-slider-track]').children);
        //console.log(childrenArray)
        return childrenArray.filter(function(item) {
          return item.tagName !== 'STYLE';
        })
      },
      get firstItem() {
        return head(this.items);
      },
      get lastItem() {
        return last(this.items);
      }
    }
  }

  function setEvents(data) {
    data.triggerPrev.addEventListener('click', partial(triggerClickSequence, data, 'prev'));
    data.triggerNext.addEventListener('click', partial(triggerClickSequence, data, 'next'));

    var debounceScroll = debounce(partial(setControlsDisabled, data), 66);
    data.track.addEventListener('scroll', debounceScroll);

    return data;
  }

  function setDirection(data, direction) {
    data.direction = direction; 
    return data;
  }

  function findNextItem(data) {
    var i = 0;
    var trackBox = data.track.getBoundingClientRect();
    var items = data.items;

    for (; i < items.length; i += 1) {
      var itemBox = items[i].getBoundingClientRect();

       // Item right edge is outside the scroll container
      if (itemBox.right > trackBox.right) {
        return items[i];
        break;
      }
    }
  }

  function findPrevItem(data) {
    var i = 0;
    var trackBox = data.track.getBoundingClientRect();
    var items = data.items;

    for (var i = items.length - 1; i >= 0; i--) {
      var itemBox = items[i].getBoundingClientRect();
      
      // Item left edge is outside the scroll container
      if (itemBox.left < trackBox.left) {
        return items[i];
        break;
      }
    }
  }

  function getScrollOffset(data) {
    var trackBox = data.track.getBoundingClientRect();

    if (data.direction === 'next') {
      var item = findNextItem(data);
      data.offset = trackBox.left - item.getBoundingClientRect().left;
    }

    if (data.direction === 'prev') {
      var item = findPrevItem(data);
      data.offset = trackBox.right - item.getBoundingClientRect().right
    }

    return data;
  }

  // API method: scrollX
  function scrollX(data, offsetX) {
    data.offset = offsetX;
    setScroll(data);
  }

  // API method: scrollToStart
  function scrollToStart(data) {
    data.offset = data.track.scrollWidth;
    setScroll(data);
  }

  // API method: scrollToStart
  function scrollToEnd(data) {
    var firstItemLeft = head(data.items).getBoundingClientRect().left;
    var lastItemRight = last(data.items).getBoundingClientRect().right;

    data.offset = firstItemLeft - lastItemRight;
    setScroll(data);
  }

  function setScroll(data) {
    data.isScrolling = true;
    data.track.scrollLeft += -data.offset;
  }

  function setControlsDisabled(data) {
    canScrollPrev(data)
      ? data.triggerPrev.removeAttribute('disabled')
      : data.triggerPrev.setAttribute('disabled', true);

    canScrollNext(data)
      ? data.triggerNext.removeAttribute('disabled')
      : data.triggerNext.setAttribute('disabled', true);

    return data;
  }

  function setControlsVisibility(data) {
    // Slider without items
    if (!data.items.length) return data;

    if (hasScrollOverflow(data)) {
      data.triggerPrev.setAttribute('hidden', true);
      data.triggerNext.setAttribute('hidden', true);
    } else {
      data.triggerPrev.removeAttribute('hidden');
      data.triggerNext.removeAttribute('hidden');
    }

    return data;
  }

  function canScrollNext(data) {
    // Slider without items
    if (!data.items.length) return false;

    return !Boolean(Math.abs(data.lastItem.getBoundingClientRect().right - data.track.getBoundingClientRect().right) <= 1);
  }

  function canScrollPrev(data) { 
    // Slider without items
    if (!data.items.length) return false;

    return !Boolean(data.track.scrollLeft === 0);
  }

  function hasScrollOverflow(data) { 
    // Slider without items
    if (!data.items.length) return false;

    return Boolean(data.lastItem.getBoundingClientRect().right <= data.track.getBoundingClientRect().right);
  }
})(POV);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');
  if (!$newAddressForm.length) return;

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    $(this).toggleClass('btn--icon-active');
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $('#AddressDetails_' + formId).toggleClass('hide');

  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) return;

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


theme.blogTagSelect = (function() {
  
  var trigger = $('[data-tag-select]');
  
  trigger.on('change', function() {
    
    var url = this.selectedOptions[0].getAttribute('data-url');

    if (url) window.location = url;
    return false;
  });
})();


theme.carouselMobile = (function() {
  function CarouselMobile(container) {
    this.container = container;
    this.btns = this.container.querySelectorAll('.carousel__btn');
    this.slides = this.container.querySelectorAll('.carousel__slide');
    
    this.init();
  }
  
  CarouselMobile.prototype = {
    init: function() {
      this.initEvents();
    },
    
    initEvents: function() {
      this.btns.forEach(function(btn) {
        btn.addEventListener('click', this.btnOnClick.bind(this));
      }, this);
    },
    
    btnOnClick: function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      
      var btn = evt.currentTarget;
      var index = btn.getAttribute('data-slide');
      
      this.btns.forEach(function(button) {
        button.removeAttribute('aria-pressed');
      });
      btn.setAttribute('aria-pressed', 'true');
      
      this.slides.forEach(function(slide) {
        slide.classList.add('small--hide');
      });
      this.slides[index].classList.remove('small--hide');
    }
  };
  
  document.querySelectorAll('.carousel').forEach(function(carousel) {
    new CarouselMobile(carousel);
  });
  
})();


theme.productVideo = (function() {
  var trigger = $('[data-video]');
  
  trigger.on('click', function(evt){
    evt.preventDefault();
    
    var id = this.getAttribute('data-video');
    var markup = $('<div class="product-video"><div class="aspect-ratio"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div>') 
    $(document.body).append(markup);
  });
  
  $(document).on('click', '.product-video', function(){
    $(this).remove();
  });
  
})();


$(document).ready(function() {
  // Target tables to make them scrollable
  slate.rte.wrapTable({
    tables: document.querySelectorAll('.rte table'),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
}); 

theme.modal = (function () {
  function Modal(element) {
    this.trigger = element;
    this.target = document.getElementById(this.trigger.getAttribute('aria-controls'));
    this.dialog = this.target.querySelector('[role="dialog"]');
    this.closeBtn = this.target.querySelector('.modal-btn');
    this.name = this.trigger.getAttribute('aria-controls');

    this.init();
    return this;
  }

  Modal.prototype = {
    init: function () {
      this.initEvents();
    },

    initEvents: function () {
      this.trigger.addEventListener('click', this.triggerOnClick.bind(this));
      this.closeBtn.addEventListener('click', this.closeOnClick.bind(this));
      this.target.addEventListener('click', this.targetOnClick.bind(this));
    },

    triggerOnClick: function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      this.open();
    },

    closeOnClick: function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      this.close();
    },

    targetOnClick: function (evt) {
      if (evt.target.id === this.target.id) {
        this.close();
      }
    },

    open: function () {
      document.body.classList.add('modal-body-overflow');
      this.target.removeAttribute('hidden');
      this.closeBtn.focus();

      document.body.addEventListener(
        'keypress',
        function (evt) {
          if (evt.keyCode == 27) {
            this.close();
          }
        }.bind(this),
        { once: true }
      );
    },

    close: function () {
      document.body.classList.remove('modal-body-overflow');
      this.target.setAttribute('hidden', 'true');
    }
  };

  // Initialize modals for elements with [data-modal-init] attribute
  document.querySelectorAll('[data-modal-init]').forEach(function (element) {
    window.POV.Modal = window.POV.Modal || [];
    window.POV.Modal.push(new Modal(element));
  });

})();
  
  
theme.articleTOC = (function() {
  var wrap = document.querySelector('[data-js-expand]');
  if (!wrap) return; // Check if the element exists

  var panel = wrap.querySelector('ul');
  var trigger = wrap.querySelector('button');

  // Set attributes and classes
  panel.id = 'toclist';
  trigger.classList.add('rte-toc-btn', 'btn', 'btn--cta');
  trigger.setAttribute('aria-controls', 'toclist');
  trigger.setAttribute('aria-expanded', 'false');

  // Remove empty anchor links and set attribute for non-empty links
  Array.from(panel.querySelectorAll('a')).forEach(function(link) {
    if (link.textContent.trim() === '') {
      link.parentNode.remove(); // Remove the parent <li> element of empty <a>
    } else {
      link.setAttribute('data-scroll-init', '');
    }
  });

  // Click event listener for the trigger button
  trigger.addEventListener('click', function() {
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    if (!isExpanded) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.textContent = 'Collapse';
      animate(panel, 'normal');
    } else {
      animate(panel, 'reverse');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.textContent = 'Expand';
    }
  });

  // Animation function using Web Animations API
  function animate(element, direction) {
    var AnimateOptions = {
      duration: 180,
      fill: 'both',
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    };

    if (!POV.support.WebAnimations) return;

    element.setAttribute('data-is-animating', true);

    var keyframes = [
      { height: '70px' },
      { height: element.offsetHeight + 'px' }
    ];

    var animation = element.animate(keyframes, AnimateOptions);
    animation.onfinish = function() {
      element.removeAttribute('data-is-animating');
      this.cancel();
    };
  }
})();

  
theme.scrollToElement = (function() {
  function scrollToElement(element) {
    this.$trigger = $(element);
    
    var href = this.$trigger.attr('href');
    
    if ($(href).length) {
      this.$target = $(href);
    } else {
      this.$target = $('[name="' + href.replace('#', '') + '"]')
    }
    
    if (!$(href).length) return;
    
    this.$header = $('[data-section-id="header"], [data-scroll-header]');
    this.init();
  }
  
  scrollToElement.prototype = $.extend({}, scrollToElement.prototype, {
    
    init: function() {
      this.initEvents();
    },
    
    initEvents: function() {
      var _triggerOnClick = this.triggerOnClick.bind(this);
      this.$trigger.on('click', _triggerOnClick);
    },
    
    triggerOnClick: function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      
      var topHeight = $.makeArray(this.$header).reduce(function(acc, element) {
        acc += element.getBoundingClientRect().height;
        return acc;
      }, 0);
      
      var targetTop = window.scrollY + this.$target[0].getBoundingClientRect().top - topHeight;

      if (POV.support.ScrollBehavior) {
        window.scroll({ top: targetTop, left: 0, behavior: 'smooth' });
        
      } else {
        $('html, body').animate({ scrollTop: targetTop }, 800);
      }
    }
    
  });
  
  $('[data-scroll-init]').each(function(index) {
    new scrollToElement(this);
  });
  
})();

theme.overflowCollapsible  = (function() {
  $('.overflow-show').on('click', function(){
    toggle($(this));
  })
  
  function toggle($btn) {
    ($btn.attr('aria-expanded') === 'false')
    ? expand($btn)
    : collapse($btn)
  }
  
  function expand($btn) {
    $btn.attr('aria-expanded', 'true').text('Read less');
    $btn.next().attr('aria-hidden', 'false');
  }
  
  function collapse($btn) {
    $btn.attr('aria-expanded', 'false').text('Read more');;
    $btn.next().attr('aria-hidden', 'true');
  }
})();
  
// Article comments button
$(document).ready(function() {
  $('[data-js-comments]').on('click', function(evt){
    evt.preventDefault();
    
    var disqus = $('#disqus_thread');
    disqus.attr('hidden') ? disqus.removeAttr('hidden') : disqus.attr('hidden', '');
  });
});
  
  
/**
 * POV Collapsible
 *
 * @namespace POV.Collapsible
 * @return {array} - Collapsible objects
 * 
 * @fires collapsible:before:collapse
 * @fires collapsible:before:expand
 * @fires collapsible:after:collapse
 * @fires collapsible:after:expand
 * Events are fired on the panel node
 */

POV.Collapsible = (function() {
  const instances = nodeList('[data-collapsible-title]').map(getElements).map(setEvents);

  const publicAPI = {
    instances: instances,
    reinit: reinit
  };

  return publicAPI;

  function getElements(trigger) {
    var panel = getPanelElement(trigger);
    return {
      trigger: trigger,
      panel: panel,
      expand: expand.bind(null, trigger, panel),
      collapse: collapse.bind(null, trigger, panel),
      isCollapsed: isCollapsed.bind(null, trigger)
    }
  }

  function setEvents(collapsible) {
    // Prevent application from breaking when markup is not corectly setup
    if (!collapsible.panel) return collapsible;

    collapsible.trigger.addEventListener('click', partial(toggle, collapsible.trigger, collapsible.panel));
    return collapsible;
  }

  function toggle(trigger, panel) {
    isCollapsed(trigger) ? expand(trigger, panel) : collapse(trigger, panel);
  }

  function expand(trigger, panel) {
    if (!isCollapsed(trigger)) return;
    trigger.setAttribute('aria-expanded', true);
    panel.removeAttribute('aria-hidden');
    animate(panel, 'normal');
  }

  function collapse(trigger, panel) {
    if (isCollapsed(trigger)) return;
    trigger.setAttribute('aria-expanded', false);
    panel.setAttribute('aria-hidden', true);
    animate(panel, 'reverse');
  }

  /**
   * Panel is next element with attr [data-collapsible-panel] after trigger or after trigger parent
   * @param {DOMElement} trigger
   * @return {DOMElement|null} panel element or null
   */
  function getPanelElement(trigger) {
    var triggerParent = trigger.parentElement;

    if (siblingIsPanel(trigger)) {
      return trigger.nextElementSibling;
    } else if (siblingIsPanel(triggerParent)) {
      return triggerParent.nextElementSibling;
    }

    return null;
  }

  /**
   * @param {DOMElement} element - trigger or trigger parent
   * @return {boolean} 
   */
  function siblingIsPanel(element) {
    return element.nextElementSibling && element.nextElementSibling.hasAttribute('data-collapsible-panel');
  }

  /**
   * @param {DOMElement} element - trigger [data-collapsible-title]
   * @return {boolean}
   */
  function isCollapsed(element) {
    return element.getAttribute('aria-expanded') === 'false';
  }

  /**
   * Animates collapsible panel
   * @param {DOMElement} element - [data-collapsible-panel]
   * @param {string} direction - animation direction
   */
  function animate(element, direction) {
    var type = direction === 'reverse' ? 'collapse' : 'expand';
    POV.emit('collapsible:before:' + type, {}, element);

    if (!POV.support.WebAnimations) return;
    
    element.setAttribute('data-is-animating', true);
    
    var keyframes = [
      { height: getStartHeight(element) },
      { height: element.offsetHeight + 'px' }
    ];

    var options = {
      duration: 180,
      fill: 'both',
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    };
    
    element.animate(keyframes, options).onfinish = function() {
      element.removeAttribute('data-is-animating');
      POV.emit('collapsible:after:' + type, {}, element);
      this.cancel();
    };
  }

  function getStartHeight(element) {
    var heightS = element.getAttribute('data-collapsible-panel-height-s');
    var heightL = element.getAttribute('data-collapsible-panel-height-l');
    var breakPoint = element.getAttribute('data-collapsible-panel-breakpoint');

    if (heightS && heightL && breakPoint) {
     return window.matchMedia('(max-width: ' + breakPoint + ')').matches
        ? heightS
        : heightL
    } else {
      return 0;
    }
  }

  function reinit() {
    const existingTriggers = instances.map(instance => instance.trigger);
    const newTriggerElements = nodeList('[data-collapsible-title]').filter(trigger => !existingTriggers.includes(trigger));
    const validInstances = POV.Collapsible.instances.filter(instance => document.body.contains(instance.trigger));
    const newInstances = newTriggerElements.map(getElements).map(setEvents);

    POV.Collapsible.instances = validInstances.concat(newInstances);
  }

})();


(function LazyPicture() {
  'use strict';

  POV.LazyPicture = {
    init: init,
    load: loadTarget
  }

  var support = POV.support;
  nodeList('[data-lazy-picture]').map(init);
  
  function init(picture) {
    support.IntersectionObserver
    ? initObserver(intersection).observe(picture)
    : loadTarget(picture);
  }
  
  function intersection(entries, observer) {
    entries.filter(isIntersecting).map(target).filter(notLoaded).map(function(target){
      observer.unobserve(target);
      loadTarget(target);
    });
  };

  function loadTarget(target) {
    if (!notLoaded(target)) return;

    support.ImageDecode
    ? compose(setSourceAfterDecode, pictureData)(target)
    : compose(setSourceAfterLoad, pictureData)(target);

    return target;
  }

  function setSourceAfterDecode(data) {
    if (!data.highRez) return;

    if (!data.img.complete) {
      return compose(loadEnd, animate, setSource)(data);
    }
    
    newImg(data.highRez).decode().then(function() {
      compose(loadEnd, animate, setSource)(data);
    });
    
    return data;
  }

  function setSourceAfterLoad(data) {
    newImg(data.highRez).onload = function() {
      compose(loadEnd, animate, setSource)(data);
    };
    
    return data;
  }

  function newImg(src) {
    var newImg = document.createElement('img');
    newImg.src = src;
    newImg.crossOrigin = 'Anonymous';

    return newImg;
  }

  function setSource(data) {
    attrUpdate(nodeList('source, img', data.picture));
    return data;
  };

  function attrUpdate(nodes) {
    nodes.forEach(function(node) {
      var name = (node.nodeName === 'IMG') ? 'src' : 'srcset';
      var value = node.getAttribute('data-lazy-evaluation');

      node.removeAttribute('data-lazy-evaluation');
      node.setAttribute(name, value);
    });
  }

  function pictureData(picture) {
    var img = picture.querySelector('img');

    return {
      lowRez: lowRezSrc(img),
      highRez: highRezSrc(picture),
      picture: picture,
      img: img
    }
  }

  function lowRezSrc(img) {
    return (img.currentSrc && img.currentSrc.length) ? img.currentSrc : img.src;
  }

  function highRezSrc(picture) {
    if (!support.MatchMedia) return false;

    var src = currentSrcElement(picture).getAttribute('data-lazy-evaluation');
    if (!src) return;

    var srcList = currentSrcElement(picture).getAttribute('data-lazy-evaluation').replace(' 2x', '').split(',')

    return (window.devicePixelRatio === 1) ? head(srcList) : last(srcList);
  }

  function animate(data) {
    var picture = data.picture;

    if (support.CSStransition) {
      picture.addEventListener('transitionend', function transitionend() {
        picture.setAttribute('data-lazy-loaded', true);
        picture.removeAttribute('style');
        picture.removeEventListener('transitionend', transitionend);
      });
    } else {
      picture.setAttribute('data-lazy-loaded', true);
    }

    return data;
  }

  function loadEnd(data) {
    if (data.img.complete) {
      data.picture.removeAttribute('aria-busy');
    } else {
      data.img.onload = function() {
        data.picture.removeAttribute('aria-busy');
      }
    }
    return data;
  }

  function initObserver(fn) {
    return new IntersectionObserver(fn, {
      rootMargin: '0px',
      threshold: 0.0
    });
  }

  function currentSrcElement(picture) {
    var sources = nodeList('source', picture);
    var img = picture.querySelector('img');
    var matchedSource = head(sources.filter(sourceMatchMedia));

    return matchedSource || img;
  }

  function sourceMatchMedia(source) {
    return window.matchMedia(source.media).matches;
  }

  function isIntersecting(entry) {
    return (entry.isIntersecting === true || typeof entry.isIntersecting === 'undefined');
  }

  function target(entry) {
    return entry.target;
  }

  function notLoaded(target) {
    return target.hasAttribute('aria-busy');
  }
})();


// Country selector
(function CountrySelector() {
  // Select all elements with the class 'country-selector'
  var countrySelectors = document.querySelectorAll('.country-selector');

  countrySelectors.forEach(function (element) {
    var toggle = element.querySelector('.country-selector-toggle');
    var countryList = element.querySelector('.country-list');

    // Add click event listener to the toggle button
    toggle.addEventListener('click', function () {
      if (element.classList.contains('open')) {
        toggle.setAttribute('aria-expanded', 'false');
        element.classList.remove('open');
      } else {
        element.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();


// Geolocation
window.addEventListener('DOMContentLoaded', getGeoLocation);
function getGeoLocation() {
  
  // Use sesionstorage location
  var locationFromSession = JSON.parse(sessionStorage.getItem('POV-GEOLOCATION'));
  if (locationFromSession) {
    POV.emit('geolocation:load', locationFromSession);
    return;
  }

  // New visit, no cached location, do API call
  var req = new XMLHttpRequest();
  req.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      var data = JSON.parse(this.response).location;
      var geolocation = { country: data.country, region: data.region };
      sessionStorage.setItem('POV-GEOLOCATION', JSON.stringify(geolocation));
      POV.emit('geolocation:load', geolocation);
    };
  }
  req.open('GET', 'https://geo.ipify.org/api/v2/country?apiKey=at_49m0dR2WfLVkEm8D4zLnRBfFTpit7', true);
  req.send();
}

// Geolocation Body Attributes
(function geoLocationBodyAttrs() {

  window.addEventListener('geolocation:load', updateBodyAttrs);
  function updateBodyAttrs(event) {

    var geolocation = event.detail;

    document.body.setAttribute('data-geo-country', geolocation.country);
    document.body.setAttribute('data-geo-region', geolocation.region);
  }
})();

// Geo Redirect Panel
(function geoRedirect() {

  var configEl = document.querySelector('[data-geo-redirect]');
  var shouldRun = (POV.Cookie.read('POV_georedirect_no_show') !== 'true');

  if (configEl && shouldRun) window.addEventListener('geolocation:load', init);
  
  function init(event) {

    var country = event.detail.country;

    var config = JSON.parse(configEl.innerHTML);
    var entitled = config.entitled;
    var panel = document.querySelector('[data-section-id="' + config.sectionId + '"]');
    var redirectLink = panel.querySelector('[data-georedirect-link]');
    var closeTrigger = panel.querySelector('[data-georedirect-close]');

    /**
     * Panel close event init
     */
    closeTrigger.addEventListener('click', closePanel);

    // Show panel if country is in the section config
    if (entitled.indexOf(country) !== -1) showPanel();

    /**
     * User panel close cookie set
     * POV.Cookie.write(name, value, days);
     */
    function setCloseCookie() {
      POV.Cookie.write('POV_georedirect_no_show', 'true', 365);
    }

    /**
     * Set panel visibility
     * Set close cookie
     * Submit dismiss event to GA
     * Animate panel state
     */
    function closePanel() {
      panel.setAttribute('hidden', 'hidden');
      setCloseCookie();
      animate(panel, 'reverse');
    }

    /**
     * Set new link HREF
     * Set panel visibility
     * Submit display event to GA
     * Animate panel state
     */
    function showPanel() {
      redirectLink.href = window.location.href.replace(config.substr, config.newSubStr);
      panel.removeAttribute('hidden');
      animate(panel, 'normal');
    }

    /**
     * Animates collapsible panel
     * @param {DOMElement} element Element to be animated
     * @param {String} direction Animation direction
     */
    function animate(element, direction) {
      if (!POV.support.WebAnimations) return;

      element.setAttribute('data-is-animating', true);

      element.animate([{ height: 0 }, { height: panel.offsetHeight + 'px' }], {
        duration: 320,
        fill: 'both',
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        direction: direction
      }).onfinish = function() {
        this.cancel();
        element.removeAttribute('data-is-animating');
      };
    }
  }
})();


// Notice Banner
(function noticeBanner() {
  var panels = document.querySelectorAll('[data-notice-banner]');
  panels.forEach(init);

  function init(panel) {
    var closeTrigger = panel.querySelector('[data-notice-banner-close]');
    if (!closeTrigger) return;
    closeTrigger.addEventListener('click', closePanel);

    /**
     * User panel close cookie set
     * POV.Cookie.write(name, value, days);
     */
    function setCloseCookie() {
      var bannerHash = panel.dataset.noticeBanner;
      POV.Cookie.write('POV_notice_banner_hide_'+bannerHash, 'true', 30);
    }

    /**
     * Set panel visibility
     * Set close cookie
     * Animate panel state
     */
    function closePanel() {
      panel.setAttribute('hidden', 'hidden');
      setCloseCookie();
      animate(panel, 'reverse');
    }

    /**
     * Set panel visibility
     * Animate panel state
     */
    function showPanel() {
      panel.removeAttribute('hidden');
      animate(panel, 'normal');
    }

    /**
     * Animates collapsible panel
     * @param {DOMElement} element Element to be animated
     * @param {String} direction Animation direction
     */
    function animate(element, direction) {
      if (!POV.support.WebAnimations) return;

      element.setAttribute('data-is-animating', true);

      element.animate([{ height: 0 }, { height: panel.offsetHeight + 'px' }], {
        duration: 320,
        fill: 'both',
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        direction: direction
      }).onfinish = function() {
        this.cancel();
        element.removeAttribute('data-is-animating');
      };
    }
  }
})();


(function CollectionItemHover(){
  'use strict';

  Array.from(document.querySelectorAll('[data-product-item]')).forEach(handleMouseEnter)

  function handleMouseEnter(nodeItem) {
    var picture = nodeItem.querySelector('[data-collection-item-hover]');
    if (!picture || picture.getAttribute('data-collection-item-hover') === 'loaded') return;

    var srcSetNodeList = nodeList('[data-srcset]', picture);
    var srcNodeList = nodeList('[data-src]', picture);

    srcSetNodeList.forEach(function(node){
      node.setAttribute('srcset', node.getAttribute('data-srcset'));
      node.removeAttribute('data-srcset')
    });

    srcNodeList.forEach(function(node){
      node.setAttribute('src', node.getAttribute('data-src'));
      node.removeAttribute('data-src')
    });

    picture.setAttribute('data-collection-item-hover', 'loaded');
  }

  // Reinit on filter DOM update
  window.addEventListener('filter:change', function reInit(){
    Array.from(document.querySelectorAll('[data-product-item]')).forEach(handleMouseEnter)
  });
})(); 

(function Search(){
  'use strict';

  var searchInput = nodeList('[data-search-input]');
  searchInput.forEach(function(node){
    var clearBtn = node.parentElement.querySelector('[data-search-clear]');
    node.addEventListener('input', partial(handleSearchChange, node, clearBtn));
    clearBtn.addEventListener('click', partial(handleClearClick, node, clearBtn));
  })

  function handleSearchChange(input, clearBtn) {
    input.value.length 
      ? clearBtn.removeAttribute('hidden')
      : clearBtn.setAttribute('hidden', 'hidden')
  }

  function handleClearClick(input, clearBtn) {
    input.value = '';
    input.focus();
    clearBtn.setAttribute('hidden', 'hidden');
    const event = new InputEvent('input', {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    input.dispatchEvent(event);
  }
})(); 

(function SwatchImage(){
  'use strict';

  var swatchImages = {};
  var triggers = nodeList('[data-swatch-color]');
  
  triggers.forEach(function(node){
    node.addEventListener('click', init);
  });

  function init(evt){
    evt.stopPropagation();
    evt.preventDefault();

    var attrList = this.getAttribute('data-swatch-color').split(',');
    var handle = last(attrList);
    var color = head(attrList);
    var picture = this.closest('[data-product-item]').querySelector('.item-picture-hover');

    if (!swatchImages[handle]) {
      fetch('/products/' + handle + '?view=color-image').then(function(response){
        return response.json();
      }).then(function(data) {
        swatchImages[handle] = data;
        setImage(handle, color, picture);
      });
    } else {
      setImage(handle, color, picture);
    }
  }

  function setImage(handle, color, picture) {
    nodeList('source', picture).forEach(function(node){
      node.parentElement.removeChild(node);
    });
    
    picture.querySelector('img').src = swatchImages[handle][color];
  }


  // Reinit on filter DOM update
  window.addEventListener('filter:change', function reInit(){
    var triggers = nodeList('[data-swatch-color]');
    
    triggers.forEach(function(node){
      node.addEventListener('click', init);
    });
  });
})();
